import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import PageLayout from "examples/LayoutContainers/PageLayout";
import impresLogo from "../../../assets/ImpLogo.jpg";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import safeToast from "utils/safeToast";
import { API_ENDPOINTS } from "config/api";
import { encryptText, decryptText } from "config/encryption";

function getStaffCodeFromAdminSession(parsed) {
  if (!parsed || typeof parsed !== "object") return "";
  return (
    parsed.StaffCode ||
    parsed.staffCode ||
    parsed.LoginCode ||
    parsed.loginCode ||
    parsed.Usn ||
    parsed.usn ||
    ""
  );
}

const AdminLogin = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [greetName, setGreetName] = useState("");
  const [staffCodePlain, setStaffCodePlain] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const session = localStorage.getItem("adminsessiondetails");
    if (!session) {
      safeToast.warn("No admin session found. Please verify your login code first.");
      navigate("/BasicAuth");
      return;
    }

    try {
      const decrypted = decryptText(session);
      const parsed = JSON.parse(decrypted);
      const code = getStaffCodeFromAdminSession(parsed);

      if (!code) {
        localStorage.removeItem("adminsessiondetails");
        safeToast.error("Admin session is missing staff code. Please verify again.");
        navigate("/BasicAuth");
        return;
      }

      setStaffCodePlain(String(code).trim());
      setGreetName(parsed.Usn || parsed.StaffName || parsed.staffName || String(code).trim());
    } catch (e) {
      console.error("Admin session decrypt failed:", e);
      localStorage.removeItem("adminsessiondetails");
      safeToast.error("Invalid admin session. Please verify your login code again.");
      navigate("/BasicAuth");
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (!staffCodePlain) {
      setError("Admin code is not available. Please start again from verification.");
      setLoading(false);
      return;
    }

    if (!password.trim()) {
      setError("Please enter your password.");
      setLoading(false);
      return;
    }

    try {debugger;
      const encodedAdminCode = encryptText(staffCodePlain);
      const encodedPassword = encryptText(password);
      const response = await axios.post(API_ENDPOINTS.AUTH_ADMIN.STAFF_LOGIN, {
        staffCode: encodedAdminCode,
        password: encodedPassword,
      });
      if (response && response.data) {debugger;
        localStorage.setItem("adminLogsessiondetails", response.data);
        try {
          const decrypted = decryptText(response.data);
          const parsed = JSON.parse(decrypted);
          setGreetName(parsed.Usn || parsed.StaffName || greetName || "");
        } catch {
          /* keep existing greetName */
        }
        setError("");
        setTimeout(() => {
          window.location.href = "/AdminHome";
        }, 800);
      } else {
        setError("Invalid response from server.");
      }
    } catch (err) {
      setError("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageLayout>
      <ToastContainer />
      <MDBox
        px={1}
        width="100%"
        height="100vh"
        mx="auto"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ backgroundColor: "#ffffff" }}
      >
        <Card sx={{ maxWidth: 400, width: "100%", p: { xs: 2, sm: 4 }, borderRadius: 4, boxShadow: 8, zIndex: 2 }}>
          <MDBox display="flex" flexDirection="column" alignItems="center" mb={2}>
            <MDBox component="img" src={impresLogo} alt="Impres Logo" width={70} mb={1} />
            <MDTypography variant="h4" fontWeight="bold" color="info" textAlign="center" mb={1}>
              Admin Login
            </MDTypography>
            {greetName && (
              <MDTypography variant="h6" color="success" textAlign="center" mb={1}>
                Hi, {greetName}
              </MDTypography>
            )}
            <MDTypography variant="body2" color="text" textAlign="center" mb={2}>
              Welcome back! Your admin code is verified. Please enter your password to sign in.
            </MDTypography>
          </MDBox>
          <form onSubmit={handleLogin}>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                autoFocus
              />
            </MDBox>
            {error && (
              <MDTypography color="error" variant="caption" display="block" mb={1} textAlign="center">
                {error}
              </MDTypography>
            )}
            <MDButton
              type="submit"
              variant="gradient"
              color="info"
              fullWidth
              disabled={loading || !staffCodePlain}
              sx={{ fontWeight: 600, fontSize: 16, borderRadius: 2 }}
            >
              {loading ? "Signing in..." : "Sign in"}
            </MDButton>
          </form>
        </Card>
      </MDBox>
    </PageLayout>
  );
};

export default AdminLogin;
